import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "badges" }
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "body-info" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-bold" }
const _hoisted_11 = {
  key: 0,
  class: "text-regular"
}
const _hoisted_12 = {
  key: 1,
  class: "text-regular"
}
const _hoisted_13 = { class: "text-bold" }
const _hoisted_14 = {
  key: 0,
  class: "text-regular"
}
const _hoisted_15 = {
  key: 1,
  class: "text-regular"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "text-bold" }
const _hoisted_18 = {
  key: 0,
  class: "text-regular"
}
const _hoisted_19 = {
  key: 1,
  class: "text-regular"
}
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "text-bold" }
const _hoisted_22 = {
  key: 0,
  class: "text-regular"
}
const _hoisted_23 = {
  key: 1,
  class: "text-regular"
}
const _hoisted_24 = { class: "building-info" }
const _hoisted_25 = { class: "text-bold" }
const _hoisted_26 = {
  key: 1,
  class: "text-regular"
}
const _hoisted_27 = { class: "time-div" }
const _hoisted_28 = { class: "text-paragraf" }
const _hoisted_29 = { class: "text-bold" }
const _hoisted_30 = {
  key: 0,
  class: "text-regular"
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "text-bold" }
const _hoisted_33 = {
  key: 0,
  class: "text-regular"
}
const _hoisted_34 = {
  key: 1,
  class: "text-regular"
}
const _hoisted_35 = { class: "text-bold" }
const _hoisted_36 = {
  key: 0,
  class: "text-regular"
}
const _hoisted_37 = {
  key: 1,
  class: "text-regular"
}
const _hoisted_38 = { class: "text-paragraf" }
const _hoisted_39 = { class: "text-bold" }
const _hoisted_40 = {
  key: 0,
  class: "text-regular"
}
const _hoisted_41 = {
  key: 1,
  class: "text-regular"
}
const _hoisted_42 = { class: "text-bold" }
const _hoisted_43 = {
  key: 0,
  class: "text-regular"
}
const _hoisted_44 = {
  key: 1,
  class: "text-regular"
}
const _hoisted_45 = { class: "text-bold" }
const _hoisted_46 = {
  key: 0,
  class: "text-regular"
}
const _hoisted_47 = {
  key: 1,
  class: "text-regular"
}
const _hoisted_48 = {
  key: 0,
  class: "presentation"
}
const _hoisted_49 = { class: "text-bold" }
const _hoisted_50 = {
  key: 0,
  class: "text-regular"
}
const _hoisted_51 = {
  key: 1,
  class: "text-regular"
}

import LayoutOverlay from '@/design-system/templates/LayoutOverlay.vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import BadgeSquare from '@/design-system/atoms/BadgeSquare.vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { PROJECT_TYPE, PROJECT_STATUS, BADGE_COLORS } from '@/api-client/models/project/Constants'
import { useStore } from 'vuex'
import { Project } from '@/api-client/models/project/Contracts'

import useNavigateTo from '@/composables/useNavigateTo'
import { formatter } from '../formatter'
interface EMITS {
  (e: 'projectDetailsClose'): void
}
type Props = {
  project: Project
  internal: boolean
  selectedBadgeColor: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectDetails',
  props: {
    project: {},
    internal: { type: Boolean },
    selectedBadgeColor: {}
  },
  emits: ["projectDetailsClose"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const { locale, t } = useI18n()
const vuex = useStore()
const { navigateTo } = useNavigateTo()

const internal = computed(() => {
  if (props.internal) {
    return true
  } else {
    return false
  }
})
const badgeType = computed(() => {
  return PROJECT_TYPE[props.project.type][locale.value]
})
const buildings = computed(() => vuex.getters.allBuildings.map((x) => x.properties))
const selectedBuilding = computed(() => vuex.getters['mapview/selectedBuildingId'])
const correctBuilding = computed(() => {
  if (props.project.constructionId === selectedBuilding.value) {
    return true
  } else {
    return false
  }
})

const constructionName = computed(() => {
  const constructionIdToFind = props.project.constructionId
  const construction = buildings.value.find((item) => item.id === constructionIdToFind)
  return construction?.name
})

function moveTo() {
  if (props.project.constructionId) {
    navigateTo(props.project.constructionId)
    emits('projectDetailsClose')
  }
}
const emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutOverlay, {
    class: "project-details",
    onCloseOverlay: _cache[2] || (_cache[2] = ($event: any) => (emits('projectDetailsClose')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.project.externalId && internal.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.project.externalId) + " - ", 1))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.project.name), 1)
          ]),
          _createVNode(ButtonText, {
            id: "project-exit",
            class: "text-button",
            iconLeft: require('@/design-system/assets/icons/Icon-X-Small.svg'),
            size: "extra-small",
            onOnClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('projectDetailsClose')))
          }, null, 8, ["iconLeft"])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "horizontal-divider" }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(BadgeSquare, {
            badgeText: badgeType.value,
            size: 'small',
            color: 'primary'
          }, null, 8, ["badgeText"]),
          _createVNode(BadgeSquare, {
            badgeText: _unref(PROJECT_STATUS)[_ctx.project.status][_unref(locale)],
            size: 'small',
            style: _normalizeStyle({ backgroundColor: _unref(BADGE_COLORS)[_ctx.project.status] })
          }, null, 8, ["badgeText", "style"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (internal.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('general__data__projectnumber')) + ": ", 1),
                    (_ctx.project.externalId)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.project.externalId), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, " - "))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('general__text__description')) + ": ", 1),
                (_ctx.project.name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.project.name), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, " - "))
              ]),
              (internal.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('general__data__project-leader')) + ": ", 1),
                    (_ctx.project.projectManager)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.project.projectManager), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, " - "))
                  ]))
                : _createCommentVNode("", true),
              (internal.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('general__text__budget')) + ": ", 1),
                    (_ctx.project.budget)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(formatter)(parseFloat(_ctx.project.budget.toString()) / 1000, _unref(locale), {
                    format: { type: 'intl-number', maximumFractionDigits: 1 }
                  })) + " tkr ", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_23, " - "))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(t)('general__text__building')) + ": ", 1),
                (!correctBuilding.value)
                  ? (_openBlock(), _createBlock(ButtonText, {
                      key: 0,
                      class: "building",
                      buttonText: constructionName.value,
                      iconLeft: require('@/design-system/assets/icons/Icon-Arrow-up-right.svg'),
                      size: "extra-small",
                      onOnClicked: _cache[1] || (_cache[1] = ($event: any) => (moveTo()))
                    }, null, 8, ["buttonText", "iconLeft"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(constructionName.value), 1))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass({ external: !internal.value, internal: internal.value })
              }, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)('general__text__time-range')) + ": ", 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('general__text__move-in-date')) + ": ", 1),
                    (_ctx.project.moveDate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.project.moveDate), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_31, " - "))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_32, [
                      _createTextVNode(_toDisplayString(_unref(t)('general__text__start-date')) + ": ", 1),
                      (_ctx.project.startDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.project.startDate), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_34, " - "))
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_35, [
                      _createTextVNode(_toDisplayString(_unref(t)('general__text__end-date')) + ": ", 1),
                      (_ctx.project.endDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.project.endDate), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_37, " - "))
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)('general__text__size')) + ": ", 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_39, [
                      _createTextVNode(_toDisplayString(_unref(t)('general__text__GFA-Renovation')) + ": ", 1),
                      (_ctx.project.btaRebuild)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.project.btaRebuild) + " m²", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_41, " - "))
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_42, [
                      _createTextVNode(_toDisplayString(_unref(t)('general__text__GFA-New-Construction')) + ": ", 1),
                      (_ctx.project.btaNewConstruction)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.project.btaNewConstruction) + " m²", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_44, " - "))
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_45, [
                      _createTextVNode(_toDisplayString(_unref(t)('general__text__GFA-Extension')) + ": ", 1),
                      (_ctx.project.btaExtension)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.project.btaExtension) + " m²", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_47, " - "))
                    ])
                  ])
                ])
              ], 2)
            ]),
            (internal.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_unref(t)('general__text__presentation')) + ": ", 1),
                  _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                  (_ctx.project.description)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.project.description), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_51, " - "))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})